
import React from "react";
import { Box, Typography } from "@material-ui/core";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import RadioButtonUncheckedIcon from "@material-ui/icons/RadioButtonUnchecked";

export const QuizInlineCardItem = ({ label, status }) => {
  const answered = status === "respondido";
  const iconStyle = { fontSize: 16, marginRight: 6 };

  return (
    <Box display="flex" alignItems="center" ml={3}>
      {answered ? (
        <CheckCircleIcon style={{ ...iconStyle, color: "#4caf50" }} />
      ) : (
        <RadioButtonUncheckedIcon style={{ ...iconStyle, color: "#9e9e9e" }} />
      )}
      <Typography variant="body2">{label}</Typography>
    </Box>
  );
};
